import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Zap, Loader2, LogIn } from "lucide-react";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Button } from "../components/ui/button";
import { useAuth } from "../auth";

const formatError = (detail) => {
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || "").join(" ");
  return "Login gagal. Coba lagi.";
};

export default function AdminLogin() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(username, password);
      navigate("/admin");
    } catch (err) {
      setError(formatError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      data-testid="admin-login-page"
      className="min-h-screen bg-gray-950 flex items-center justify-center px-6"
    >
      <div className="w-full max-w-md">
        <div className="flex items-center justify-center gap-2 mb-8">
          <span className="w-10 h-10 rounded-xl bg-[#E60000] flex items-center justify-center">
            <Zap className="w-5 h-5 text-white" strokeWidth={2.5} />
          </span>
          <span className="font-heading font-extrabold text-2xl tracking-tight text-white">
            Risma<span className="text-[#E60000]">Cell</span>
          </span>
        </div>

        <form
          onSubmit={handleSubmit}
          data-testid="admin-login-form"
          className="bg-white rounded-3xl p-8 md:p-10 shadow-2xl space-y-5"
        >
          <h1 className="font-heading text-2xl font-bold text-gray-900">
            Login Admin
          </h1>

          {error && (
            <div
              data-testid="admin-login-error"
              className="bg-red-50 border border-red-200 text-[#E60000] text-sm font-medium rounded-xl px-4 py-3"
            >
              {error}
            </div>
          )}

          <div className="space-y-2">
            <Label htmlFor="admin-username">Username</Label>
            <Input
              id="admin-username"
              data-testid="admin-username-input"
              type="text"
              placeholder="Username admin"
              autoComplete="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="admin-password">Password</Label>
            <Input
              id="admin-password"
              data-testid="admin-password-input"
              type="password"
              placeholder="••••••••"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <Button
            type="submit"
            data-testid="admin-login-submit"
            disabled={loading}
            className="w-full bg-[#E60000] hover:bg-red-700 text-white font-semibold py-6 rounded-full active:scale-[0.98] transition-[background-color,transform]"
          >
            {loading ? (
              <Loader2 className="w-5 h-5 animate-spin" />
            ) : (
              <>
                <LogIn className="w-5 h-5 mr-2" />
                Masuk
              </>
            )}
          </Button>

          <a
            href="/"
            className="block text-center text-sm text-gray-500 hover:text-gray-900 transition-colors"
          >
            Kembali ke beranda
          </a>
        </form>
      </div>
    </div>
  );
}
